import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Reviews } from "@/components/Reviews";
import { Credentials } from "@/components/Credentials";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="grain min-h-screen bg-[#FCFCFC]">
      <Nav />
      <main>
        <Hero />
        <Reviews />
        <Credentials />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
